export default __webpack_public_path__ + "static/media/timer.12f663c5.png";